"use strict";

import angular from "angular";

angular.module("nucont.accounting.prospect", ["nucont.shared"]);
require("./prospect.routes");
